import { FieldErrors } from 'react-hook-form'
import { TUser } from '../types'

export function uniqueErrors(errors: FieldErrors<Partial<TUser>>) {
  return Array.from(new Map(Object.values(errors)
    .map((item) => [item.message, item]))?.values())
}
